

















































































































































































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Select from '@/components/Select.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import moment from 'moment'
import Icon from '@/components/Icon.vue'
import { ETableColumnType, ITableColumn, ITableConfig } from '@/interfaces'
import TableInputDateRangePicker from '@/components/inputsV2/TableInputDateRangePicker.vue'
import InputNumberRange from '@/components/inputsV2/InputNumberRange.vue'
import { ESortOrder } from '@zunta/configurations'
// @ts-ignore
import Teleport from 'vue2-teleport'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { getSelectContentLabel } from '@/utils/helpers'

let debounceT: number = 800

@Component({
  components: {
    SelectV2,
    InputV2,
    MultiSelectV2,
    InputNumberRange,
    TableInputDateRangePicker,
    Icon,
    Select,
    SearchInput,
    DateInput,
    Teleport
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object as PropType<ITableConfig>,
      required: true
    },
    configClearBtn: {
      type: Object as any,
      required: true
    }
  }
})
export default class TableHeadFilters extends Vue {
  ETableColumnType: any = ETableColumnType
  getSelectContentLabel: Function = getSelectContentLabel
  moment: any = moment
  filters: any = {}
  lastFocused: any = ''

  get routeQuery () {
    const query: any = { ...this.$route.query }
    if (query.limit && query.skip) {
      query.limit = parseInt(query.limit)
      query.skip = parseInt(query.skip)
    } else {
      return {}
    }
    return query
  }

  get hasSearch () {
    return this.$props.config.columns &&
      this.$props.config.columns.length &&
      this.$props.config.columns.findIndex((item: any) => item.hasSearch) > -1
  }

  get hasSearchValues () {
    const filters = JSON.parse(JSON.stringify(this.filters))
    if (filters.limit) {
      delete filters.limit
    }
    if (filters.skip !== undefined) {
      delete filters.skip
    }
    return Object.values(filters).find((item: any) => item !== undefined && item !== null && item !== '')
  }

  get activeSort () {
    return (field: string) =>
      this.filters.sortBy === field && (this.filters.sortOrder === ESortOrder.ASC || this.filters.sortOrder === ESortOrder.DESC)
  }

  get DESCSort () {
    return (field: string) => this.filters.sortBy === field && this.filters.sortOrder === ESortOrder.ASC
  }

  beforeMount () {
    if (this.$props.config.debounceTime !== undefined) {
      debounceT = this.$props.config.debounceTime
    }
    this.$props.config.columns.forEach((column: any) => {
      if (column.hasSearch) {
        this.$set(this.filters, column.searchKey, '')
      }
    })
    if (this.$props.config.columns.find((col: ITableColumn) => col.hasSort)) {
      this.$set(this.filters, 'sortBy', '')
      this.$set(this.filters, 'sortOrder', '')
    }
    this.parseQuery()
  }

  mounted () {
    // this.$watch('routeQuery', (newValue, oldValue) => {
    //   console.log('123')
    //   if (oldValue.limit !== newValue.limit || oldValue.skip !== newValue.skip) {
    //     return
    //   }
    //   this.parseQuery()
    //   this.$emit('change', newValue)
    // }, { deep: true })

    this.$watch('disabled', (value) => {
      if (!value && this.lastFocused) {
        setTimeout(() => this.lastFocused.focus(), 50)
      }
    })
  }

  parseQuery () {
    if (this.$props.config.useQuery) {
      this.$nextTick(() => {
        Object.keys(this.filters).forEach((key: string) => {
          if (!this.routeQuery[key]) {
            return
          }
          const col = this.$props.config.columns.find((col: ITableColumn) => col.type === this.ETableColumnType.multiselect && col.searchKey === key)
          if (col) {
            this.filters[key] = Array.isArray(this.routeQuery[key])
              ? col.options.filter((opt: any) => this.routeQuery[key].includes(opt.value))
              : col.options.filter((opt: any) => this.routeQuery[key] === opt.value)
          } else {
            this.filters[key] = this.routeQuery[key]
          }
        })
      })
    }
  }

  setLastFocusedElement (elem: any) {
    if (this.$props.disabled) {
      return
    }
    this.lastFocused = elem
  }

  preventChar (e: any) {
    if (/\d/gm.test(e.key)) {
      e.preventDefault()
    }
  }

  setItem (field: string, value: any) {
    if (!this.filters[field] && value) {
      this.$set(this.filters, field, value)
      return
    }

    this.filters[field] = value
  }

  emitChange () {
    if (!this.$props.disabled) {
      this.$emit('change', this.filters)
    }
  }

  // @Debounce(debounceT)
  emitChangeWithDebounce () {
    if (!this.$props.disabled) {
      this.$emit('debounceChange', this.filters)
    }
  }

  setSort (field: string, hasSort: boolean) {
    if (!hasSort) {
      return
    }

    if (this.filters.sortBy === field) {
      switch (this.filters.sortOrder) {
        case null:
          this.filters.sortOrder = ESortOrder.ASC
          break
        case ESortOrder.ASC:
          this.filters.sortOrder = ESortOrder.DESC
          break
        case ESortOrder.DESC:
          this.filters.sortOrder = null
          this.filters.sortBy = null
          break
      }
      return
    }

    this.filters.sortBy = field
    this.filters.sortOrder = ESortOrder.ASC
  }

  clearFilters () {
    for (const [field] of Object.entries(this.filters)) {
      if (field === 'limit') {
        continue
      }
      if (field === 'skip') {
        this.filters[field] = 0
      }
      this.filters[field] = ''
    }
    this.lastFocused = ''
  }

  getSelectTooltipText (column: any) {
    const { filters } = this
    if (!column.options || !filters[column.searchKey]) {
      return null
    }
    const res = (typeof column.options === 'function' ? column.options() : column.options).find((el: any) => el.value === filters[column.searchKey])
    return res ? res.content : ''
  }

  getNumberRangeTooltipText (column: any) {
    const { filters } = this
    return filters[column.searchKey] && filters[column.searchKey].includes(';')
      ? `R: ${filters[column.searchKey].replace(/;/gm, '-')}`
      : filters[column.searchKey]
  }

  showToolTip (value: any, index: number, selector: string = 'input') {
    if (!this.$el) {
      return false
    }

    const $el: Element | null = this.$el.querySelector(`.table-head-col-wrapper:nth-child(${index + 1}) ${selector}`)
    if (!$el || !value) {
      return ''
    }

    const pl: number = parseInt(window.getComputedStyle($el).paddingLeft as string, 10)
    const pr: number = parseInt(window.getComputedStyle($el).paddingRight as string, 10)

    let $tmp: Element = document.createElement('small')
    $tmp.classList.add('position-absolute')
    $tmp.classList.add('opacity-0')
    $tmp.innerHTML = `${value}`

    document.body.append($tmp)
    // @ts-ignore
    const offsetWidthTmp: number = $tmp.offsetWidth
    $tmp.remove()
    // @ts-ignore
    const offsetWidth: number = $el.offsetWidth - pr - pl - 3 > 0 ? $el.offsetWidth - pr - pl - 3 : 0
    // @ts-ignore
    return offsetWidthTmp > offsetWidth
      ? value
      : ''
  }
}
